export default {"src":"/_next/static/media/tech_dots.61e87396.svg","height":367,"width":501,"blurWidth":0,"blurHeight":0};